module.exports = __webpack_public_path__ + "img/EWarElephant64_ua.930d7548.webp";